define('app/views/guest_checkout_user_address_info_view',['app/setup'], function(takhfifan) {

  takhfifan.guestCheckoutUserAddressInfoView = Backbone.View.extend({

    events: {
      'click #tkhGuestCustomerAddressInfoSubmitBtn': 'submitGuestCustomerInfo'
    },

    initialize: function(options) {
      Backbone.Validation.bind(this);
      var _this = this;
      this.$submitBtn = $("#tkhGuestCustomerAddressInfoSubmitBtn");
      this.submitBtnText = $("#tkhGuestCustomerAddressInfoSubmitBtn").text();

      takhfifan.eventHub.on('guest_customer_address_info:saved', function(data) {
        this.enableSubmitBtn();
        takhfifan.eventHub.trigger('shipping:method_updated',data);
        _this.$el.hide();
      }, this);

      takhfifan.eventHub.on('checkout:payment', function() {
        _this.$el.hide();
      }, this);

      takhfifan.eventHub.on('checkout:guestaddress', function() {
        _this.$el.show();
      }, this);

      takhfifan.eventHub.on('checkout:shipping', function() {
        _this.$el.show();
      }, this);

      takhfifan.eventHub.on('checkout:login', function() {
        _this.$el.hide();
      }, this);

      takhfifan.eventHub.on('guest_customer_address_info:submit', function(data) {
        _this.submitGuestShipping();
      });

      takhfifan.eventHub.on('guest_customer_address_info:error', function(data) {
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: data
        });
        this.enableSubmitBtn();
      }, this)
    },

    submitGuestShipping: function() {
      var _this=this;
      var payload = {};
      this.$(":input").each(function(index){
        if(!_.isUndefined($(this).attr('name'))) {
          payload[$(this).attr('name')] = $(this).val();
          if($(this).attr('name') == 'region') {
            payload['region_id'] = $(this).val();
          }
        }
      });
      this.model.set(payload, { validate: true });
      if(this.model.isValid()) {
        this.model.save(this.$el.data('url'));
      }else{
        this.enableSubmitBtn();
      }
    },

    submitGuestCustomerInfo: function(evt){
      evt.preventDefault();
      this.disableSubmitBtn();
      this.submitGuestShipping();
    },

    disableSubmitBtn: function(){
      this.$submitBtn.prop('disabled',true).empty().append('<div class="btn-text"><span class="spinner"></span></div>');
    },

    enableSubmitBtn: function(){
      this.$submitBtn.prop('disabled',false).empty().append(this.submitBtnText);
    }

  });

});

